import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";

import { Button } from "primereact/button";

import { faArrowRightFromBracket } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import MsGraph from "../../../../utils/MsGraphApiCall";
import { translationKeys } from "../../../models/app-translation-keys";

import "./TermsOfUseRejectedPage.scss";

export const TermsOfUseRejectedPage: FunctionComponent = () => {
  const { t } = useTranslation();
  const { instance: pca } = useMsal();

  const logout = () => MsGraph.handleLogout(pca);

  return (
    <div className="rejected-terms-of-use-container">
      <span>{t(translationKeys.termsOfUseAndDataPrivacyPolicy.rejected)}</span>

      <Button
        onClick={logout}
        label={t(translationKeys.global.logout)}
        icon={<FontAwesomeIcon icon={faArrowRightFromBracket} />}
      />
    </div>
  );
};
